import { useTranslation } from 'react-i18next';
import { useEventNameConstructor, useSendEvents } from '../../core/hooks';
import { EVENTS as E, LINKS, SUPPORT_EMAIL } from '../../core/constants';
import * as S from './styled';

export const LegalFooter = ({ screenId = '' }: { screenId?: string }) => {
  const { t } = useTranslation();
  const sendEvents = useSendEvents({ screenId });
  const getEventName = useEventNameConstructor({ screenId });

  const onLinkClick = (type: 'privacy' | 'terms') => {
    sendEvents(getEventName(E.CLICK), { [E.LR]: type });
    window.open(LINKS[type]);
  };

  return (
    <S.Footer className="ignore-inheritance">
      <S.Text>{t('footer_company_info')}</S.Text>
      <S.Text dangerouslySetInnerHTML={{ __html: t('copyright') }} />
      <S.Text
        dangerouslySetInnerHTML={{
          __html: t('footer_contact', {
            email: `<a href="${LINKS.contact}">${SUPPORT_EMAIL}</a>`,
          }),
        }}
      />
      <S.Links>
        <S.Link type="button" id="link-to-terms" onClick={() => onLinkClick('terms')}>
          {t('terms')}
        </S.Link>
        <S.Link type="button" id="link-to-privacy" onClick={() => onLinkClick('privacy')}>
          {t('privacy')}
        </S.Link>
      </S.Links>
    </S.Footer>
  );
};
